// src/utils/ga.tsx
import { siteConfig } from '../../config/siteConfig';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}
export {};

export function sendPageview(path:any) {
  if (siteConfig.ctx !== 'nyc') return;   // only track NYC
  if (typeof window === "undefined") return;
  if (!window.gtag) return;

  window.gtag("event", "page_view", {
    page_path: path,
    page_title: document.title,
    site: siteConfig.ctx,
    //debug_mode: true,   // <–– force GA DebugView to display the event
  });
}
